
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

interface SkillComparison {
  [key: string]: number;
}

interface PerformanceComparisonProps {
  skillRatings: SkillComparison;
  topCandidatesComparison: SkillComparison;
}

const PerformanceComparison = ({ skillRatings, topCandidatesComparison }: PerformanceComparisonProps) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Performance Comparison</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <div className="flex items-center justify-between text-sm mb-2">
            <div className="flex items-center">
              <div className="w-3 h-3 bg-roundone-purple rounded-full mr-2"></div>
              <span className="text-muted-foreground">This candidate</span>
            </div>
            <div className="flex items-center">
              <div className="w-3 h-3 bg-blue-400 rounded-full mr-2"></div>
              <span className="text-muted-foreground">Top candidates avg.</span>
            </div>
          </div>
          
          {Object.entries(skillRatings).map(([skill, rating]) => {
            const topAvg = topCandidatesComparison[skill];
            return (
              <div key={skill} className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-sm font-medium">{skill}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="flex-1 h-2 bg-secondary rounded-full">
                    <div
                      className="bg-roundone-purple h-2 rounded-full"
                      style={{ width: `${rating}%` }}
                    />
                  </div>
                  <div className="w-10 text-xs text-right">{rating}%</div>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="flex-1 h-2 bg-secondary rounded-full">
                    <div
                      className="bg-blue-400 h-2 rounded-full"
                      style={{ width: `${topAvg}%` }}
                    />
                  </div>
                  <div className="w-10 text-xs text-right">{topAvg}%</div>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default PerformanceComparison;
